
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class DossierActionConfirmDialog extends Vue {
  @Prop({ default: false })
  value!: boolean;

  /** i18n key for modal title */
  @Prop({ default: "" })
  titleKey!: string;

  /** i18n key for modal body */
  @Prop({ default: "" })
  descriptionKey!: string;

  /** Used when popupTitle is omitted (e.g. action button label key) */
  @Prop({ default: "" })
  fallbackTitleKey!: string;

  get displayTitle(): string {
    const key =
      (this.titleKey && this.titleKey.trim()) || this.fallbackTitleKey;
    return key ? (this.$t(key) as string) : "";
  }

  get displayDescription(): string {
    const key = this.descriptionKey && this.descriptionKey.trim();
    return key ? (this.$t(key) as string) : "";
  }

  close(): void {
    this.$emit("input", false);
    this.$emit("cancel");
  }

  confirm(): void {
    this.$emit("input", false);
    this.$emit("confirm");
  }
}
